var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBeer = function SvgBeer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3101 393.05C63.3501 393.05 63.3501 429.05 99.3901 429.05C135.43 429.05 135.43 393.05 171.47 393.05C207.51 393.05 207.51 429.05 243.55 429.05C279.59 429.05 279.59 393.05 315.64 393.05C351.69 393.05 351.68 429.05 387.73 429.05C423.78 429.05 423.77 393.05 459.82 393.05",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M419.49 380.89L475.95 310.04C475.95 310.04 396.8 327.64 370.53 332.06C264.18 349.98 72.21 335.38 34.53 332.39C44.57 346.52 54.62 360.66 64.66 374.79",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.77 337.84V194.06",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.86 220.71V168.92",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.86 332.51V256.69",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.35 157.35L162.31 152.35",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.57 336.6V335.81V319.28V302.44V285.19V241.1V220.96V198.64V178.59V160",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M254.94 160.03H254.93L254.67 160.11V167.44V337.84",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M254.67 160.11H253.97",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.72 132.23C156.48 128.98 155.81 125.47 155.81 121.81C155.81 105.63 168.93 92.5098 185.11 92.5098C201.29 92.5098 214.41 105.63 214.41 121.81C214.41 124.37 214.08 126.86 213.47 129.22",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253.94 159.97C254.27 160 254.6 160.02 254.93 160.03C255.75 160.09 256.56 160.11 257.39 160.11C263.63 160.11 269.56 158.78 274.91 156.39",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M216.11 129.11C215 125.3 214.41 121.28 214.41 117.12C214.41 93.3799 233.66 74.1299 257.4 74.1299C275.52 74.1299 291.02 85.3399 297.34 101.21",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162.31 152.35C160.05 164.23 149.6 173.21 137.07 173.21C131.82 173.21 126.93 171.63 122.86 168.92C115.93 164.32 111.37 156.45 111.37 147.51C111.37 133.32 122.88 121.81 137.07 121.81C145.53 121.81 153.04 125.9 157.72 132.22",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.19 258.52C142.136 258.52 151.01 249.646 151.01 238.7C151.01 227.754 142.136 218.88 131.19 218.88C120.244 218.88 111.37 227.754 111.37 238.7C111.37 249.646 120.244 258.52 131.19 258.52Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M216.11 129.11C215.22 129.12 214.34 129.15 213.47 129.22",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179.35 157.35C178.48 160.56 178.01 163.95 178.01 167.44C178.01 177.79 182.11 187.17 188.77 194.06C195.74 201.28 205.51 205.77 216.34 205.77C237.51 205.77 254.67 188.61 254.67 167.44C254.67 164.93 254.43 162.48 253.97 160.11C253.96 160.06 253.95 160.02 253.94 159.97",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M274.92 156.39C280.99 163.17 289.81 167.44 299.63 167.44C307.56 167.44 314.86 164.65 320.57 160C328.02 153.91 332.79 144.65 332.79 134.28C332.79 115.97 317.94 101.13 299.63 101.13C298.86 101.13 298.1 101.16 297.34 101.21",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M178.47 92.5098C187.146 92.5098 194.18 85.4762 194.18 76.7998C194.18 68.1235 187.146 61.0898 178.47 61.0898C169.794 61.0898 162.76 68.1235 162.76 76.7998C162.76 85.4762 169.794 92.5098 178.47 92.5098Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M320.5 230.5C320.5 230.5 357.5 188.5 375 198C390 204 395.5 249 320.5 294",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M321.5 187C352 159.5 384.22 160.875 403.5 183C434 218 398.5 295 321 326",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBeer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/beer.svg";